module.exports = __webpack_public_path__ + "img/2_1.8d374948.png";